export const MenuLists = ({openListMenuId, list, handleOpenActionModal}) => {
    return (
        <>
            {openListMenuId === list.id && (
                <div className="boardList__dropdown">
                    <button
                        type="button"
                        className="boardMenu__item"
                        onClick={() =>
                            handleOpenActionModal({
                                targetType: "list",
                                action: "archive",
                                listId: list.id,
                            })
                        }
                    >
                        Archive list
                    </button>

                    <button
                        type="button"
                        className="boardMenu__item"
                        onClick={() =>
                            handleOpenActionModal({
                                targetType: "list",
                                action: "delete",
                                listId: list.id,
                            })
                        }
                    >
                        Delete list
                    </button>
                </div>
            )}
        </>
    )
}